<template>
  <div>
    <HeaderItem />
    <div class="subject">
      <div class="list-group">
        <routeTabComponent />
        <div class="panel">
          <div class="InternetThings" v-loading="projectLoading">
            <el-button
              class="addporject"
              type="primary"
              size="small "
              icon="el-icon-circle-plus"
              @click="setprojectInfo(false)"
              >添加项目</el-button
            >
            <div class="borderLineDescripe aeroiotflex_between">
              <div class="aeroiotflex_row">
                <div
                  class="tipBoxItem aeroiotflex_center"
                  v-for="(item, index) in tipsList"
                  :key="index"
                  v-show="item.value != '0'"
                  :class="
                    item.name == '项目总数' ? 'projectObj' : 'unProjectObj'
                  "
                >
                  {{ item.name }}：{{ item.value }}
                </div>
              </div>
              <div class="aeroiotflex_row">
                <el-input
                  class="projectInput"
                  v-model="input"
                  size="mini"
                  @input="searchProject"
                  style="margin-right: 10px; width: 213px"
                  placeholder="请输入项目名称或监测物名称"
                  ><i slot="prefix" class="el-input__icon el-icon-search"></i
                ></el-input>
              </div>
            </div>

            <div
              v-if="projectList.length == 0"
              class="noMoniterBox aeroiotflex_center"
            >
              <div class="noMoniterBoxImg aeroiotflex_center">
                <img src="@/assets/monitorListNoData.png" alt="" />
              </div>
              <div>项目列表为空，快去创建项目吧～</div>
            </div>
            <div class="projectListDiaplay">
              <div
                class="projectListItem"
                v-for="(item, index) in projectList"
                :key="index"
              >
                <div class="aeroiotflex_row">
                  <div class="projectimgBox aeroiotflex_center">
                    <el-image class="projectimg aeroiotflex_center">
                      <div slot="error" class="image-slot">
                        <img src="@/assets/project.png" alt="" />
                      </div>
                    </el-image>
                  </div>
                  <div class="aeroiotflex_col">
                    <div
                      class="aeroiotflex_row aeroiotflex_row_spacle"
                      style="margin-bottom: 14px"
                    >
                      <div class="projectListItem-name">{{ item.name }}</div>
                      <div class="projectListItem-tips aeroiotflex_row">
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[1]"
                        >
                          桥梁: {{ item.sizeMap[1] }}
                        </div>
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[2]"
                        >
                          边坡: {{ item.sizeMap[2] }}
                        </div>
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[3]"
                        >
                          水库: {{ item.sizeMap[3] }}
                        </div>
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[4]"
                        >
                          河堤: {{ item.sizeMap[4] }}
                        </div>
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[5]"
                        >
                          积水: {{ item.sizeMap[5] }}
                        </div>
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[6]"
                        >
                          隧道运营: {{ item.sizeMap[6] }}
                        </div>
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[7]"
                        >
                          建筑: {{ item.sizeMap[7] }}
                        </div>
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[8]"
                        >
                          水务: {{ item.sizeMap[8] }}
                        </div>
                        <div
                          class="projectListItem-tips-item"
                          v-if="item.sizeMap[9]"
                        >
                          隧道施工: {{ item.sizeMap[9] }}
                        </div>
                      </div>
                    </div>
                    <div class="aeroiotflex_row">
                      <div
                        class="
                          projectListItem-monitorListButton
                          aeroiotflex_center
                        "
                        :class="
                          item.openMonitorList
                            ? 'activeMonitorListButton'
                            : 'unActiveMonitorListButton'
                        "
                        @click="item.openMonitorList = !item.openMonitorList"
                      >
                        <div style="margin-right: 4px">监测物列表</div>
                        <i
                          class="el-icon-caret-top"
                          v-if="item.openMonitorList"
                        ></i>
                        <i class="el-icon-caret-bottom" v-else></i>
                      </div>
                      <el-button
                        @click="setprojectInfo(item)"
                        class="projectinfo"
                        type="primary"
                        size="small"
                        plain
                        >项目属性</el-button
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="monitorListInProjectBox aeroiotflex_row"
                  v-if="item.openMonitorList"
                >
                  <div
                    class="monitorListInProjectBox-item aeroiotflex_row"
                    v-for="(itemM, indexM) in item.monitorObjects"
                    :key="indexM"
                    :class="
                      itemM.topWarningLevel == '2'
                        ? 'redBorder'
                        : itemM.topWarningLevel == '5'
                        ? 'yellowBorder'
                        : itemM.topWarningLevel == '4'
                        ? 'blueBorder'
                        : itemM.topWarningLevel == '1'
                        ? 'orangeBorder'
                        : ''
                    "
                  >
                    <el-image
                      class="monitorimg aeroiotflex_center"
                      :src="itemM.photo"
                    >
                      <div slot="error" class="image-slot">
                        <img src="@/assets/monitor.png" alt="" />
                      </div>
                    </el-image>
                    <div
                      class="aeroiotflex_col monitorBox-title-box"
                      style="height: 58px; justify-content: space-between"
                    >
                      <div
                        class="monitorBox-title"
                        :title="itemM.name"
                        @click="openMonitorPage(itemM)"
                      >
                        {{ itemM.name }}
                      </div>
                      <div class="monitorBoxTips">
                        设备 {{ itemM.online }}/{{ itemM.total }}
                      </div>
                    </div>

                    <div
                      class="warningModule"
                      v-if="
                        itemM.topWarningLevel && itemM.topWarningLevel == '5'
                      "
                      :style="
                        itemM.topWarningLevel == '5'
                          ? 'background:rgba(235, 206, 42, 1)'
                          : ''
                      "
                    >
                      预警 {{ itemM.warning }}
                    </div>
                    <div
                      class="warningModule"
                      v-if="
                        itemM.topWarningLevel && itemM.topWarningLevel == '2'
                      "
                      :style="
                        itemM.topWarningLevel == '2' ? 'background:red' : ''
                      "
                    >
                      预警 {{ itemM.warning }}
                    </div>
                    <div
                      class="warningModule"
                      v-if="
                        itemM.topWarningLevel && itemM.topWarningLevel == '4'
                      "
                      :style="
                        itemM.topWarningLevel == '4' ? 'background:blue' : ''
                      "
                    >
                      预警 {{ itemM.warning }}
                    </div>
                    <div
                      class="warningModule"
                      v-if="
                        itemM.topWarningLevel && itemM.topWarningLevel == '1'
                      "
                      :style="
                        itemM.topWarningLevel == '1' ? 'background:orange' : ''
                      "
                    >
                      预警 {{ itemM.warning }}
                    </div>
                  </div>
                  <div
                    class="monitorListInProjectBox-item aeroiotflex_center"
                    style="fontsize: 12px"
                    v-if="item.monitorObjects.length == 0"
                  >
                    暂无监测物
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-dialog
          class="projectdialog"
          :title="projectmsg.id ? '编辑项目' : '添加项目'"
          :visible.sync="projectDialog"
          :append-to-body="true"
          width="580px"
          @open="getmonirortypes"
        >
          <div>
            <ul class="projectinfo-form">
              <li class="aeroiotflex_row">
                <div class="projectinfo-form-label aeroiotflex_row">
                  <span class="require" style="margin-top: 5px">*</span>
                  <label for="">项目名称</label>
                </div>
                <div class="projectinfo-form-right">
                  <el-input
                    v-model="projectmsg.name"
                    size="small"
                    placeholder="请输入"
                  ></el-input>
                </div>
              </li>
              <li class="aeroiotflex_row">
                <div class="projectinfo-form-label aeroiotflex_row">
                  <span class="require" style="margin-top: 5px">&nbsp;</span>
                  <label for="">项目简介</label>
                </div>
                <div class="projectinfo-form-right">
                  <el-input
                    type="textarea"
                    size="small"
                    placeholder="请输入"
                    :autosize="{ minRows: 2 }"
                    resize="none"
                    :maxlength="50"
                    show-word-limit
                    v-model="projectmsg.desc"
                  ></el-input>
                </div>
              </li>
              <li class="aeroiotflex_row" v-if="!projectmsg.id">
                <div class="projectinfo-form-label aeroiotflex_row">
                  <span class="require" style="margin-top: 5px">*</span>
                  <label for="">监测物类型</label>
                </div>
                <div class="projectinfo-form-right">
                  <el-select
                    v-model="projectmsg.types"
                    multiple
                    placeholder="请选择"
                    style="width: 100%"
                    size="small"
                  >
                    <el-option
                      v-for="item in projecttypes"
                      :key="item.code"
                      :label="item.type"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </div>
              </li>
            </ul>
          </div>
          <div slot="footer" class="dialog-footer aeroiotflex_center">
            <el-button
              class="borderbtn aeroiotflex_center"
              @click="projectDialog = false"
              style="width: 100px; border-radius: 0"
              size="small"
              >取消</el-button
            >
            <el-button
              class="fullbtn aeroiotflex_center"
              type="primary"
              size="small"
              style="width: 100px; border-radius: 0; background-color: #6c85ff"
              :loading="dialogloading"
              :disabled="disabled"
              @click="submitproject"
              >确定</el-button
            >
          </div>
        </el-dialog>
      </div>

      <SignIn></SignIn>
    </div>
    <telephoneModule />
  </div>
</template>

<script>
import HeaderItem from "@/components/HeaderItem";
import SignIn from "@/components/SignIn";
import telephoneModule from "@/components/telephoneModule";
import routeTabComponent from "@/components/routeTabComponent";

export default {
  components: {
    HeaderItem,
    SignIn,
    routeTabComponent,
    telephoneModule,
  },
  data() {
    return {
      input: "",
      projectList: [],
      projectDialog: false,
      dialogloading: false,
      projectmsg: {
        name: "",
        id: "",
        desc: "",
        types: [],
      },
      projecttypes: [],
      tipsList: [
        {
          name: "项目总数",
          value: "0",
        },
        {
          name: "桥梁监测",
          value: "0",
        },
        {
          name: "边坡监测",
          value: "0",
        },
        {
          name: "水库监测",
          value: "0",
        },
        {
          name: "河堤监测",
          value: "0",
        },
        {
          name: "积水监测",
          value: "0",
        },
        {
          name: "隧道运营监测",
          value: "0",
        },
        {
          name: "建筑监测",
          value: "0",
        },
        {
          name: "水务监测",
          value: "0",
        },
        {
          name: "隧道施工监测",
          value: "0",
        },
      ],
      projectLoading: false,
    };
  },
  mounted() {
    this.loadingProject();
  },
  computed: {
    disabled() {
      return !this.projectmsg.name || (!this.projectmsg.id && this.projectmsg.types.length == 0);
    },
  },
  methods: {
    openMonitorPage(itemM) {
      window.open(itemM.url, "_blank");
    },
    searchProject(e) {
      if (e) {
        let projectList = JSON.parse(JSON.stringify(this.projectList));
        let newProjectList = [];

        for (let i = 0, j = projectList.length; i < j; i++) {
          // 寻找项目名称匹配的
          if (projectList[i].name.indexOf(e) != -1) {
            projectList[i].openMonitorList = true;
            newProjectList.push(projectList[i]);
            continue;
          } else {
            let monitorList = new Array();
            for (
              let m = 0, q = projectList[i].monitorObjects.length;
              m < q;
              m++
            ) {
              if (projectList[i].monitorObjects[m].name.indexOf(e) != -1) {
                projectList[i].openMonitorList = true;
                monitorList.push(projectList[i].monitorObjects[m]);
              }
            }
            if (monitorList.length > 0) {
              projectList[i].monitorObjects = monitorList;
              newProjectList.push(projectList[i]);
            }
          }
        }
        this.projectList = newProjectList;
      } else {
        this.loadingProject();
      }
    },
    loadingProject() {
      this.projectLoading = true;
      let url = this.$apis.projectData;

      // let url = 'http://192.168.1.153:9521/usercenter/projects'

      this.$axios
        .get(url)
        .then((res) => {
          if (res.data.code == 200) {
            // 处理数据
            let countArray = [0, 0, 0, 0, 0, 0, 0, 0, 0];
            res.data.data.forEach((x) => {
              x.openMonitorList = false;
              for (let i = 0; i < 9; i++) {
                if (x.sizeMap[i + 1]) {
                  countArray[i] = countArray[i] + x.sizeMap[i + 1];
                }
              }
              if (x.sizeMap[1]) {
                countArray[0] = countArray[0] + x.sizeMap[1];
              }
            });

            // 处理展开 预警的全部展开
            let warningProjectList = res.data.data.filter((x) => {
              return x.hasWarning == true;
            });
            if (warningProjectList.length == 0) {
              res.data.data[0].openMonitorList = true;
            } else {
              res.data.data.forEach((x) => {
                if (x.hasWarning) {
                  x.openMonitorList = true;
                }
              });
            }

            // 计算顶部综合
            this.tipsList.forEach((x) => {
              if (x.name == "项目总数") {
                x.value = res.data.data.length;
              } else if (x.name == "桥梁监测") {
                x.value = countArray[0];
              } else if (x.name == "边坡监测") {
                x.value = countArray[1];
              } else if (x.name == "水库监测") {
                x.value = countArray[2];
              } else if (x.name == "河堤监测") {
                x.value = countArray[3];
              } else if (x.name == "积水监测") {
                x.value = countArray[4];
              } else if (x.name == "隧道运营监测") {
                x.value = countArray[5];
              } else if (x.name == "建筑监测") {
                x.value = countArray[6];
              } else if (x.name == "水务监测") {
                x.value = countArray[7];
              } else if (x.name == "隧道施工监测") {
                x.value = countArray[8];
              }
            });
            this.projectList = res.data.data;
          } else {
          }
          this.projectLoading = false;
        })
        .catch((e) => {
          this.projectLoading = false;
          console.log("错误", e);
        });
    },
    setprojectInfo(info) {
      if (info) {
        this.projectmsg = info;
      } else {
        this.projectmsg = {
          name: "",
          desc: "",
          types: [],
        };
      }
      this.projectDialog = true;
    },
    submitproject() {
      if (this.disabled) return;
      this.dialogloading = true;
      let url = this.$apis.addproject;
      if (this.projectmsg.id) url = this.$apis.editproject;
      this.$axios
        .post(url, this.projectmsg)
        .then((res) => {
          if (res.data.code == 200) {
            this.input = '';
            this.projectDialog = false;
            this.loadingProject();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }

          this.dialogloading = false;
        })
        .catch((e) => {
          console.log("错误", e);
        });
    },
    getmonirortypes(){
      this.$axios
        .get(this.$apis.getmonirortypes)
        .then((res) => {
          if (res.data.code == 200) {
            this.projecttypes = res.data.data;
          } else {
          }
        })
        .catch((e) => {
        });
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.addporject {
  background-color: #6c85ff;
  border-radius: 0;
  border-color: #6c85ff;
  margin-top: 10px;
}
.projectinfo {
  border-color: #8e98a5;
  color: #8e98a5;
  height: 30px;
  margin-left: 20px;
  border-radius: 0;
  background: none;
}
.projectinfo:hover,
.projectinfo:focus,
.projectinfo:active {
  border-color: #6c85ff;
  color: #6c85ff;
  border-radius: 0;
  background: none;
}
.projectdialog /deep/ .el-dialog {
  border-radius: 0;
}
.projectdialog /deep/ .el-dialog__header {
  background-color: #6c85ff;
  padding: 10px 20px;
}
.projectdialog /deep/ .el-dialog__title {
  color: #ffffff;
}
.projectdialog /deep/ .el-dialog__headerbtn .el-icon-close {
  color: #ffffff;
  font-size: 24px;
}
.projectdialog /deep/ .el-dialog__headerbtn {
  top: 10px;
  right: 10px;
}
.projectinfo-form {
  padding: 0;
  margin: 0;
}
.projectinfo-form .require {
  color: #ff0000;
}
.projectinfo-form li {
  margin-bottom: 25px;
  align-items: flex-start;
}
.projectinfo-form-label {
  margin-right: 10px;
  flex-shrink: 0;
  height: 30px;
  min-width: 80px;
  justify-content: flex-end;
}
.projectinfo-form-right {
  flex: 1;
}
.projectinfo-form-right /deep/ .el-input__inner,
.projectinfo-form-right /deep/ .el-textarea__inner {
  border-radius: 0;
  font-family: "";
}
.subject {
  /* 20220523 隐藏左侧栏 */
  /* position: absolute; */
  /* width: calc(100% - 50px); */
  width: 100%;
  min-height: 100vh;
  background-color: #eaedf5;
  left: 50px;
  display: flex;
  flex-direction: row;
}

.subject .list-group {
  width: 1408px;
  position: relative;
  margin: 63px 20px 20px 15px;
  min-height: 782px;
}

.subject .list-group .panel {
  border-top: 1px solid;
  border-color: #e2e4e7;
  width: 100%;
  background-color: white;
}
.InternetThings {
  min-height: 740px;
  padding: 0px 20px;
}
.borderLineDescripe {
  height: 60px;
  border-bottom: 1px dashed #e2e4e7;
}
.noMoniterBoxImg {
  width: 190px;
  height: 190px;
  background: #f4f4f4;
  border-radius: 50%;
  margin-top: 172px;
  margin-bottom: 30px;
}
.noMoniterBox {
  flex-direction: column;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}
.tipBoxItem {
  height: 23px;
  border: 1px solid #dfe1e6;
  font-size: 12px;
  font-weight: 400;
  padding: 0 10px 0 5px;
  color: #999999;
  margin-right: 10px;
}
.projectInput /deep/ .el-input__inner {
  background-color: rgba(244, 244, 244);
  border-radius: 0;
  border: none;
}
.projectimgBox {
  width: 70px;
  height: 70px;
  background: rgba(241, 243, 247);
  border-radius: 50%;
  margin: 0 16px 0 12px;
}
.projectimg /deep/ .image-slot {
  color: rgb(192, 196, 204);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.projectListItem {
  margin: 22px 0px 0px 0px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e2e4e7;
}
.projectListItem-name {
  font-size: 14px;
  font-weight: 600;
  color: #070707;
}
.projectListItem-tips {
  margin-left: 15px;
  font-size: 12px;
  font-weight: 400;
  color: #9c9c9c;
}
.projectListItem-tips-item {
  margin-right: 20px;
  position: relative;
}
.projectListItem-tips-item::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 10px;
  margin-top: 3.5px;
  margin-left: 10px;
  background: #9c9c9c;
}
.projectListItem-tips-item:last-child:after {
  content: "";
  display: none;
  position: absolute;
}
.projectListItem-monitorListButton {
  width: 92px;
  height: 30px;
  flex-direction: row;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}
.monitorListInProjectBox {
  margin-left: 99px;
  margin-top: 16px;
  width: calc(100% - 121px);
  max-width: 1192px;
  background: rgba(245, 247, 251, 1);
  position: relative;
  padding-left: 12px;
  padding-top: 12px;
  flex-wrap: wrap;
}
.monitorListInProjectBox::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(45deg) translateY(-170%) translateX(100%);
  width: 10px;
  height: 10px;
  background: rgba(245, 247, 251, 1);
}
.monitorListInProjectBox-item {
  width: 284px;
  height: 80px;
  background: rgba(255, 255, 255, 1);
  margin: 0 12px 12px 0;
  position: relative;
}
.monitorimg {
  margin: 6px 12px;
  width: 89px;
  height: 68px;
  background: rgba(241, 243, 247);
}
.monitorimg /deep/ .image-slot {
  color: rgb(192, 196, 204);
  font-size: 14px;
  width: 89px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.monitorBox-title {
  font-size: 14px;
  font-weight: 500;
  color: #070707;
  cursor: pointer;
  max-width: 170px;
  max-height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.monitorBoxTips {
  font-size: 12px;
  font-weight: 500;
  color: #9c9c9c;
}
.activeMonitorListButton {
  color: #ffffff;
  background: rgba(108, 133, 255, 1);
}
.unActiveMonitorListButton {
  color: rgba(102, 102, 102, 1);
  background: rgba(245, 247, 251, 1);
}
.warningModule {
  position: absolute;
  left: 0;
  top: 0;
  height: 18px;
  padding: 0 5px;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  background-color: red;
}

.redBorder {
  border: 1px solid rgba(239, 52, 52, 1);
}
.yellowBorder {
  border: 1px solid rgba(235, 206, 42, 1);
}
.blueBorder {
  border: 1px solid rgba(0, 142, 223, 1);
}
.orangeBorder {
  border: 1px solid #ff8a01;
}
.monitorBox-title-box {
  width: 170px;
}
@media screen and (max-width: 555px) {
  .subject {
    background: rgba(240, 241, 243, 1);
  }
  .subject .list-group {
    margin: 50px 0px 0px 0px;
    min-height: unset;
  }
  .el-scrollbar__wrap {
    margin: 0 !important;
  }
  .aeroiot-projects {
    background: rgba(240, 241, 243, 1);
    padding: 0;
    margin-top: 5px;
    justify-content: space-between;
  }
  .subject .list-group .panel {
    background-color: rgba(240, 241, 243, 1);
  }
  .subject .list-group .InternetThings {
    margin-top: 10px;
    padding: 0;
    min-height: 100vh;
    background-color: rgba(255, 255, 255);
  }
  .unProjectObj {
    display: none;
  }
  .borderLineDescripe {
    margin-left: 10px;
  }
  .monitorListInProjectBox {
    margin-left: 10px;
  }
  .monitorListInProjectBox::before {
    left: 74px;
  }
  .projectListItem-tips {
    margin-left: 0px;
    margin-top: 8px;
  }
  .aeroiotflex_row_spacle {
    flex-direction: column;
    align-items: flex-start;
  }
  .monitorListInProjectBox {
    width: calc(100% - 32px);
  }
  .monitorListInProjectBox-item {
    width: 100%;
  }
  .projectListItem-tips {
    width: 300px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .projectListItem-tips-item {
    white-space: nowrap;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/projectMannage/index.vue